module.exports = __webpack_public_path__ + "img/DRIVINGLICENSE.cd41ae92.png";